module.exports = __webpack_public_path__ + "img/1.f223124b.png";